/**
 * @generated SignedSource<<191a8341359793892a02681dbcf92128>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "CreateCompanyScheduleSettingsPayload",
            "kind": "LinkedField",
            "name": "createCompanyScheduleSettings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfCompanyScheduleSettings",
                    "kind": "LinkedField",
                    "name": "scheduleSettingsEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyScheduleSettings",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewAccessUntil",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditCompanyScheduleVisibilityCreateMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditCompanyScheduleVisibilityCreateMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "c2c1d58db832c8102f8a4e25019ddab6",
            "id": null,
            "metadata": {},
            "name": "EditCompanyScheduleVisibilityCreateMutation",
            "operationKind": "mutation",
            "text": "mutation EditCompanyScheduleVisibilityCreateMutation(\n  $model: CreateCompanyScheduleSettingsRequestInput!\n) {\n  createCompanyScheduleSettings(model: $model) {\n    scheduleSettingsEdge {\n      node {\n        id\n        viewAccessUntil\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "ecbd62c4def6e9cf7dffa2a417d8f359";
export default node;
